import EStatus from '@/helpers/estatus'
import CustomFormat from '@/helpers/custom-format'

//const listagemSolicitacoesFilters = {
export default {
  filtrarPorPesquisa: function (listSolicitacoes, pesquisa) {
    if (pesquisa) {
      switch (true) { //verifica o valor inserido no filtro de pesquisa.
        case pesquisa.length >= 3:
          return listSolicitacoes.filter((solicitacao) => {
            return solicitacao.proponente &&
              (
                solicitacao.proponente.toUpperCase().includes(pesquisa.toUpperCase())
                ||
                solicitacao.protocolo.toUpperCase().includes(pesquisa.toUpperCase())
              );
          })
          break;
        default:
          return listSolicitacoes;
          break;
      }
    } else {
      return listSolicitacoes;
    }
  },
  filtrarPorStatusANALISTA: function (listSolicitacoes, statusSelecionado) {
    switch (statusSelecionado[0].id) { //Verifica o status selecionado.
      case EStatus.statusEnum.SEM_FILTRO: {
        return listSolicitacoes;
        break;
      }
      default: {
        return listSolicitacoes.filter((solicitacao) => {
          return solicitacao.proponente
            &&
            solicitacao.idStatusSolicitacao == statusSelecionado[0].id;
        })
        break;
      }
    }
  },
  filtrarPorStatusCLIENTE: function (listSolicitacoes, statusSelecionado) {
    switch (statusSelecionado[0].id) { //Verifica o status selecionado.
      case EStatus.statusEnum.SEM_FILTRO: {
        return listSolicitacoes;
        break;
      }
      default: {
        return listSolicitacoes.filter((solicitacao) => {
          const agruparStatus =
            ((solicitacao.idStatusSolicitacao == EStatus.statusEnum.PENDENTE || solicitacao.idStatusSolicitacao == EStatus.statusEnum.EM_ANALISE) &&
              (statusSelecionado[0].id == EStatus.statusEnum.PENDENTE || statusSelecionado[0].id == EStatus.statusEnum.EM_ANALISE))
            ||
            ((solicitacao.idStatusSolicitacao == EStatus.statusEnum.AGUARDANDO_EFETIVACAO || solicitacao.idStatusSolicitacao == EStatus.statusEnum.EFETIVANDO_PROPOSTA) &&
              (statusSelecionado[0].id == EStatus.statusEnum.AGUARDANDO_EFETIVACAO || statusSelecionado[0].id == EStatus.statusEnum.EFETIVANDO_PROPOSTA));
          if (agruparStatus == true) {
            return (solicitacao.proponente && (solicitacao.idStatusSolicitacao == statusSelecionado[0].id
              || solicitacao.idStatusSolicitacao == statusSelecionado[1].id));
          } else {
            return solicitacao.proponente
              &&
              solicitacao.idStatusSolicitacao == statusSelecionado[0].id;
          }
        })
        break;
      }
    }
  },
  filtrarPorDataInicial: function (listSolicitacoes, dataInicio) {
    return listSolicitacoes.filter((solicitacao) => {
      return CustomFormat.parseFormatedDateToInt(solicitacao.dataCriacao) >= CustomFormat.parseDateToInt(dataInicio);
    })
  },
  filtrarPorDataFinal: function (listSolicitacoes, dataFim) {
    return listSolicitacoes.filter((solicitacao) => {
      return CustomFormat.parseFormatedDateToInt(solicitacao.dataCriacao) <= CustomFormat.parseDateToInt(dataFim);
    })
  },
  filtrarPorContaSeguro: function (listSolicitacoes, contaSelecionada) {
    if (contaSelecionada == "Todas as Contas" || contaSelecionada == null) {
      return listSolicitacoes
    } else {
      return listSolicitacoes.filter(solicitacao => {
        if (contaSelecionada == "Pequenas Contas") {
          return solicitacao.grandeCotacao == false;
        } else if (contaSelecionada == "Grandes Contas") {
          return solicitacao.grandeCotacao == true;
        }
      })
    }
  },
  filtrarPorPremioSeguro: function(listSolicitacoes, valorMin, valorMax) {
    if (valorMin || valorMax) {
      if (valorMin && valorMax) {
        return listSolicitacoes.filter((solicitacao) => {
          return solicitacao.premioTotal >= valorMin && solicitacao.premioTotal <= valorMax;
        })
      } else if (valorMin) {
        return listSolicitacoes.filter((solicitacao) => {
          return solicitacao.premioTotal >= valorMin;
        })
      } else if (valorMax) {
        return listSolicitacoes.filter((solicitacao) => {
          return solicitacao.premioTotal <= valorMax;
        })
      }
    } else {
      return listSolicitacoes;
    }
  },
  filtrarPortipoSolicitacao: function (listSolicitacoes, tipoSolicitacaoSelecionada) {
    if (tipoSolicitacaoSelecionada == "Todos os Tipos" || tipoSolicitacaoSelecionada == null) {
      return listSolicitacoes
    } else {
      return listSolicitacoes.filter(solicitacao => {
        if (tipoSolicitacaoSelecionada == "Interna") {
          return solicitacao.tipoSolicitacao == 'Interna';
        } else if (tipoSolicitacaoSelecionada == "Externa") {
          return solicitacao.tipoSolicitacao == 'Externa';
        } else if (tipoSolicitacaoSelecionada == "Plataforma") {
          return solicitacao.tipoSolicitacao == 'Plataforma';
        }
      })
    }
  }
}


// WEBPACK FOOTER //
// ./src/helpers/filtro.js